// extracted by mini-css-extract-plugin
export default {"switcherField":"SwitcherField-module__switcherField___R9atT","active":"SwitcherField-module__active___p_7P5"};